var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-btn-dropdown",
        {
          attrs: { label: _vm.full_name, icon: _vm.getUserIcon, flat: "" },
          model: {
            value: _vm.show_user_menu,
            callback: function($$v) {
              _vm.show_user_menu = $$v
            },
            expression: "show_user_menu"
          }
        },
        [
          _c(
            "q-list",
            { attrs: { link: "" } },
            [
              _c(
                "q-item",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.goToMessages()
                    }
                  }
                },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-icon", {
                        attrs: { name: "far fa-envelope", size: "1.5rem" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { label: "" } }, [
                        _vm._v(_vm._s(_vm.$t("messages")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.showUserProfile
                ? _c(
                    "q-item",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.goToProfile()
                        }
                      }
                    },
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-icon", {
                            attrs: { name: "far fa-cog", size: "1.5rem" }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-item-main",
                        [
                          _c("q-item-tile", { attrs: { label: "" } }, [
                            _vm._v(_vm._s(_vm.$t("edit_profile")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "q-item",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.showChangePassword()
                    }
                  }
                },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-icon", {
                        attrs: { name: "far fa-key", size: "1.5rem" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { label: "" } }, [
                        _vm._v(_vm._s(_vm.$t("change_password")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("q-item-separator"),
              _c(
                "q-item",
                {
                  nativeOn: {
                    click: function($event) {
                      return _vm.logout()
                    }
                  }
                },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-icon", {
                        attrs: { name: "far fa-sign-out-alt", size: "1.5rem" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-item-main",
                    [
                      _c("q-item-tile", { attrs: { label: "" } }, [
                        _vm._v(_vm._s(_vm.$t("sign_out")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("change-password", {
        attrs: { show_change_password: _vm.show_change_password },
        on: {
          hide_modal: function($event) {
            _vm.show_change_password = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }